// extracted by mini-css-extract-plugin
export default {"cover":"HeaderBlock_cover__7THdw","wrap":"HeaderBlock_wrap__5SDQI","header":"HeaderBlock_header__v-NLD","descr":"HeaderBlock_descr__-iD2v"};